/**
 * DropPinToolPanel — informational panel for the armed `add-pin` tool.
 * Carries no state of its own; the ✕ only cancels before a click happens.
 *
 * Owns no card chrome on purpose: MapToolbox renders it inside the shared
 * panel card (border, shadow, rounding), so adding one here would double the
 * border. Only the content is ours — the header comes from {@link MapCallout}.
 */
import { Crosshair, X } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { MapCallout } from './MapCallout';

export interface DropPinToolPanelProps {
  /** Disarm the tool and close the panel — wired to ✕ / Escape by the caller. */
  onClose: () => void;
}

export function DropPinToolPanel({ onClose }: DropPinToolPanelProps) {
  return (
    <section aria-label="New location panel" className="relative w-72 p-4">
      <Button
        variant="ghost"
        size="icon"
        aria-label="Cancel"
        onClick={onClose}
        className="absolute top-3 right-3 h-6 w-6 text-[#3c5957] hover:bg-accent"
      >
        <X className="size-3.5" aria-hidden="true" />
      </Button>

      <MapCallout title="New location" icon={<Crosshair className="size-4" aria-hidden="true" />}>
        Click the map to drop a pin.
      </MapCallout>
    </section>
  );
}
